import { Select } from 'antd';
import { NEPALI_MONTHS } from './data';

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const SelectMonth: React.FC<Props> = (props) => {
  const { value = 1, onChange } = props;

  const nepaliMonths = NEPALI_MONTHS.map((month, index) => {
    return { label: month, value: index + 1 };
  });

  return (
    <Select
      size="small"
      popupMatchSelectWidth={false}
      options={nepaliMonths}
      suffixIcon={null}
      value={value}
      onChange={onChange}
      variant="borderless"
      labelRender={({ label }) => (
        <div className="tw-font-semibold tw-text-white">{label}</div>
      )}
    />
  );
};

export default SelectMonth;
